import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    LaneStatus, CollectionServiceType, DeliveryServiceType,
} from 'app/enums/label.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LaneAwardRejectFilterRequestResponse,
} from 'app/requests/Lane/Lane.requests'

const columns = ({
    l,
    laneLinkConfig,
}: {
    l: (l: string) => string,
    laneLinkConfig?: {
        path: string[],
        params?: Record<string, string>,
    }
}): RichTableColumns<keyof LaneAwardRejectFilterRequestResponse>[] => {
    return [
        {
            id: 'laneNumber',
            headerProps: {
                children: l('AccountLane.lane'),
            },
            mapCellProps: 'laneNumber',
            componentName: 'SkyNetTableLink',
            linkConfig: laneLinkConfig,
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
        },
        {
            id: 'laneGroupNumber',
            headerProps: {
                children: l('Lane.laneGroup'),
            },
            mapCellProps: 'laneGroupNumber',
        },
        {
            id: 'laneStatus',
            headerProps: {
                children: l('AccountQuotes.laneStatus'),
            },
            filterField: 'laneStatus',
            filterType: FilterType.Array,
            mapCellProps: 'laneStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneStatus,
        },
        {
            id: 'originAirport',
            headerProps: {
                children: l('AccountLaneForm.originAirport'),
            },
            filterField: 'originAirport',
            filterType: FilterType.Array,
            mapCellProps: 'originAirport',
        },
        {
            id: 'destinationAirport',
            headerProps: {
                children: l('AccountLaneForm.destinationAirport'),
            },
            filterField: 'destinationAirport',
            filterType: FilterType.Array,
            mapCellProps: 'destinationAirport',
        },
        {
            id: 'deliveryServiceType',
            headerProps: {
                children: l('AccountLane.deliveryServiceType'),
            },
            mapCellProps: 'deliveryServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: DeliveryServiceType,
        },
        {
            id: 'collectionServiceType',
            headerProps: {
                children: l('AccountLane.collectionServiceType'),
            },
            mapCellProps: 'collectionServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: CollectionServiceType,
        },
        {
            id: 'changedBy',
            headerProps: {
                children: l('LaneGroup.changedBy'),
            },
            mapCellProps: 'changedBy',
        },
    ]
}

export default columns
